import { useCallback } from 'react';
import {
  destroy,
  activate,
  useSurveySettings,
  changeEnabled,
  updateSeq
} from '~/hooks/vendors/useSurveySettings';
import SettingStyles from '../../SettingStyle.module.scss';
import { SurveyList } from '~/components/specifics/vendors/settings/surveys/index/SurveyList';
import type { NskResponse } from '~/models/Api';
import type { Survey } from '~/models/Survey';

export const SurveySetting: React.FC = () => {
  const { data: surveys, mutate: mutateSurveys } = useSurveySettings().index();
  const handleDestroy = useCallback(
    async (surveyId: number): Promise<NskResponse> => {
      const result = await destroy(surveyId);
      await mutateSurveys?.();
      return result;
    },
    [mutateSurveys]
  );

  const handleActivate = useCallback(
    async (surveyId: number): Promise<NskResponse> => {
      const result = await activate(surveyId);
      await mutateSurveys?.();
      return result;
    },
    [mutateSurveys]
  );

  const handleChangeEnabled = useCallback(
    async (surveyId: number, value: boolean): Promise<NskResponse> => {
      const result = await changeEnabled(surveyId, value);
      await mutateSurveys?.();
      return result;
    },
    [mutateSurveys]
  );
  const handleUpdateSeq = async (newOrderSurveys: Survey[]): Promise<void> => {
    updateSeq(newOrderSurveys).then();
  };
  if (surveys === null) {
    return null;
  }

  return (
    <>
      <h3 className={SettingStyles.SettingTitle}>アンケート設定</h3>
      <SurveyList
        handleActivate={handleActivate}
        handleChangeEnabled={handleChangeEnabled}
        handleDestroy={handleDestroy}
        handleUpdateSeq={handleUpdateSeq}
        surveys={surveys}
      />
    </>
  );
};
